const defaultMessages = require('../lps/messages.js')

module.exports = Object.assign({}, defaultMessages, {})
